/* eslint-disable no-param-reassign */
import * as bootstrap from 'bootstrap'

function clearInputs(querySelector) {
  document.querySelectorAll(querySelector).forEach((input) => {
    input.checked = false
  })
}

function resetFiltersToSearchParams(
  target = document,
  urlParams = new URLSearchParams(window.location.search),
) {
  if (!urlParams.has('sort_type')) {
    urlParams.set('sort_type', 'alphabetical')
  }
  Array.from(target.querySelectorAll('input[type=checkbox],input[type=radio]')).forEach((input) => {
    if (urlParams.has(input.name, input.value)) {
      input.checked = true
    } else {
      input.checked = false
    }
  })
}

$(document).on('click', '.active-filter-pill', (event) => {
  const urlParams = new URLSearchParams(window.location.search)
  const filterType = event.currentTarget.dataset.filterType
  const filterValue = event.currentTarget.dataset.filterValue
  if (filterType === 'search') {
    document.querySelector('.search-bar input').value = ''
  } else {
    urlParams.delete(`${filterType}[]`, filterValue)
  }
  Array.from(document.querySelectorAll('.filter-sheet')).forEach((sheet) => {
    resetFiltersToSearchParams(sheet, urlParams)
  })
  document.getElementById('productSearchForm').requestSubmit()
})

$(document).on('click', '[data-action=clearAllFilters]', () => {
  const urlParams = new URLSearchParams(window.location.search)
  urlParams.delete('category_in[]')
  urlParams.delete('topic_in[]')
  urlParams.delete('price_in[]')
  urlParams.delete('rating_in[]')
  Array.from(document.querySelectorAll('.filter-sheet')).forEach((sheet) => {
    resetFiltersToSearchParams(sheet, urlParams)
  })
  document.querySelector('.search-bar input').value = ''
  document.getElementById('productSearchForm').requestSubmit()
})

$(document).on('click', '.sheet-clear-button', (event) => {
  clearInputs(event.currentTarget.dataset.inputSelector)
  document.getElementById('productSearchForm').requestSubmit()
})

$(document).on('show.bs.offcanvas', '.filter-sheet', (event) => {
  resetFiltersToSearchParams(event.currentTarget)
})

document.addEventListener('turbo:load', () => {
  // Make sure bootstrap offcanvas backdrops still work on page refreshes
  Array.from(document.querySelectorAll('.offcanvas')).map((element) => new bootstrap.Offcanvas(element))
})

document.addEventListener('turbo:submit-start', () => {
  const loadingCards = document.getElementById('loadingCards')
  const productCards = document.getElementById('productCards')
  if (!loadingCards || !productCards) return

  document.frameLoading = true
  setTimeout(() => {
    if (document.frameLoading) {
      loadingCards.style.display = 'flex'
      productCards.style.display = 'none'
    }
  }, 500)
})

document.addEventListener('turbo:frame-render', () => {
  const loadingCards = document.getElementById('loadingCards')
  const productCards = document.getElementById('productCards')
  if (!loadingCards || !productCards) return

  document.frameLoading = undefined
  loadingCards.style.display = 'none'
  productCards.style.display = 'flex'
})
